module.exports = __webpack_public_path__ + "1a2ea3112964ff8e4c154f75706ba2a4.svg";